import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Plants } from 'src/app/shared/dto/plants';
import { SessionData } from 'src/app/shared/localstorage/sessionData';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';

//i18n
import { TranslateService } from '@ngx-translate/core';
import { UserData } from 'src/app/interfaces/userInfo.interface';
import { FixedDataService } from 'src/app/services/fixed-data.service';
import { Plant } from 'src/app/interfaces/plant.interface';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { DialogoComponent } from 'src/app/shared/dialogo/dialogo.component';
import { MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class HeaderComponent implements OnInit {

  //user!: User;
  user!: UserData;
  selected?: Plants;
  safeUrl!: SafeResourceUrl;
  termsAndConditionsUrl = `${environment.apiUrl}/TermsandConditions`; 
  isAdmin = false;
  envLabel: string = '';


  // To open and close sidenav
  public isMenuOpen: boolean = true;

  // List of plants for the select
  //plants!: [Plants];
  plants: Plant [] = [];

  constructor(private fb: FormBuilder,
              private authService: AuthService,
              private translate: TranslateService,
              private fixedData: FixedDataService,
              private dialogo: MatDialog,
              private http: HttpClient,
              private router: Router,
              private sanitizer: DomSanitizer) {

    translate.addLangs(['en', 'es']);                
  }


  private getEnvironmentLabel(): string {
    const hostname = globalThis.location.hostname;
    const protocol = globalThis.location.protocol;
    const origin = `${protocol}//${hostname}/`;

    if (origin.includes('localhost') || origin.includes('-d')) {
      console.log('running DEV')
      return ' - DEV';
    } else if (origin.includes('-q')) {
      console.log('running QA')
      return ' - QA';
    } else if (origin.includes('sqip.dp.schaeffler')) {
      return '';
    }
    return '';
  }

  miFormulario: FormGroup = this.fb.group({
    languageControl: ['en'],
    selectedPlant: []
  });

  goToHome() {
    const isAdmin: boolean = SessionData.getCurrentUser().admin;
    if(!isAdmin){
      this.router.navigate(['/home']);
    }
    else{
      this.router.navigate(['/admin']);
    }
  }

  ngOnInit(): void {

    this.envLabel = this.getEnvironmentLabel();
    this.isAdmin = SessionData.getCurrentUser().admin;
    this.toggle()
    this.getTermsAndConditions();

    //inicializamos las variables con la informacion almacenada
    //this.user = SessionData.getSessionUser();
    //this.plants = SessionData.getSessionPlants();
    //this.selected = Plants.findByIdPlant(this.plants, this.user.plantId);
    this.plants = this.fixedData.plants;
    this.user = SessionData.getCurrentUser();

    const language = SessionData.getLanguage();
    this.translate.use(language);

    //Seteamos el valor y nos suscribimos a los cambios de cada campo
    this.miFormulario.get('languageControl')?.setValue(language);
    this.miFormulario.get('selectedPlant')?.setValue(this.user.plant);
    this.miFormulario.get('languageControl')?.valueChanges
      .subscribe( valor => {       
          SessionData.saveLanguage(valor);
          this.translate.use(valor);
          //TODO validar si se debe utilizar el location.reload()
          //El reload es necesario para conservar el lenguaje o planta seleccionada
          location.reload();
      });
    this.miFormulario.get('selectedPlant')?.valueChanges
      .subscribe( (plant: Plants) => {
        /*this.user.plantId = plant.plantId;
        SessionData.updateSessionUser(this.user);*/
        location.reload();
      })
  }

  logout() {
    this.authService.doLogout()
  }

  showTermsAndConditions() {

    this.dialogo.open(DialogoComponent, {
      data: {
        titulo: "Terms And Conditions",
        translate: true,
        showAcceptButton: true,
        showCloseButton: true,
        termsAndConditionsUrl: this.safeUrl,
      }
    })
      .afterClosed()
      .subscribe(resp => {
        console.log('Suscribe de dialog:', resp);
      });
  }

  getTermsAndConditions() {
    this.http.get(this.termsAndConditionsUrl, { responseType: 'text' }).subscribe(
      (data: any) => {
        const blob = new Blob([data], { type: 'text/html' });
        const url = window.URL.createObjectURL(blob);
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      },
      (error) => {
        console.error('Error loading terms and conditions:', error);
      }
    );
  }

  public toggle(): void {
    const bodyTag = document.body;
    if (this.isMenuOpen === true) {
      bodyTag.classList.add('hide');
      this.isMenuOpen = false;
    } else {
      bodyTag.classList.remove('hide');
      this.isMenuOpen = true;
    }
  }

}
